import { render, staticRenderFns } from "./sleepChild.vue?vue&type=template&id=4ec6be0a&scoped=true&"
import script from "./sleepChild.vue?vue&type=script&lang=js&"
export * from "./sleepChild.vue?vue&type=script&lang=js&"
import style0 from "./sleepChild.vue?vue&type=style&index=0&id=4ec6be0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec6be0a",
  null
  
)

export default component.exports